import { jsx as e } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as i, forwardRef as t } from "../../../external/preact/compat/dist/compat.module.js";
import d from "./hooks/useCalendar.js";
/* empty css              */
import l from "./components/CalendarControls/CalendarControls.js";
import s from "./components/CalendarGrid/CalendarGrid.js";
const m = t((o, a) => {
  const r = d(o, a), n = r.grid.config();
  return /* @__PURE__ */ e("div", { role: "none", children: [
    /* @__PURE__ */ e(l, { config: n, grid: r.grid, renderer: o.renderControl }),
    /* @__PURE__ */ e(
      s,
      {
        ref: r.cursorElementRef,
        config: n,
        cursorRootProps: r.cursorRootProps,
        grid: r.grid,
        onlyCellsWithin: o.onlyCellsWithin,
        prepare: o.prepare
      }
    )
  ] });
}), R = i(m);
export {
  R as default
};
